// extracted by mini-css-extract-plugin
export default {"container":"ReportTabWithPill_container__f+S0p","selected":"ReportTabWithPill_selected__anx+A","text":"ReportTabWithPill_text__kLx5r"};